export default __webpack_public_path__ + "static/media/storage-covered_icon.c6505eda.svg";